import { Capacitor } from "@capacitor/core";
export default class Config {
    static getOriginUrl() {
        const { hostname, protocol, port } = window.location;
        return `${protocol}//${hostname}${port ? ":" + port : ""}`;
    }

    static getBaseUrl() {
        return Capacitor.isNativePlatform()
            ? process.env.REACT_APP_API_BASE_URL
            : process.env.NODE_ENV === "production"
            ? Config.getOriginUrl()
            : "https://localhost:5000";
    }

    static getApiUrl() {
        return this.getBaseUrl() + "/api/";
    }

    static tokenRefreshRate() {
        return 45 * 60 * 1000; // refresh every 45 mins
    }
}
